import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { LoaderService } from '../../shared/loader/loader.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';
import { GlobalService } from '../../shared/services/global.service';

@Component({
  selector: 'vs-login',
  imports: [SharedModule],
  templateUrl: './login.html',
  styleUrl: './login.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Login {
  private router = inject(Router);
  private loader = inject(LoaderService);
  private authService = inject(MsalService);
  private globalService = inject(GlobalService);
  private msal = inject(MsalService);

  ngOnInit() {
    this.loader.setLoadingState.set(true);
    const redirectUrl = localStorage.getItem('vas_redirect_url');
    const businessunit = localStorage.getItem('selected-business-unit');
    this.globalService.clearStorage();
    if (redirectUrl) {
      localStorage.setItem('vas_redirect_url', redirectUrl);
    }
    if(businessunit) {
      localStorage.setItem('selected-business-unit', businessunit);
    }
    const isIframe = window.self !== window.top;
    const search = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(window.location.hash.substring(1));
    const isMsalAuthPopup =
      !!(window.opener && window.opener !== window) &&
      (search.has('code') || search.has('error') || hash.has('code') || hash.has('error'));

    if (isIframe || isMsalAuthPopup) return;

    const accounts = this.msal.instance.getAllAccounts();
    if (accounts.length === 0) {
      this.loginRedirect();
    }
  }
  navigate() {
    this.router.navigate(['home']);
  }

  loginRedirect(): void {
    this.authService.loginRedirect({
      scopes: environment.apiConfig.scopes,
    });
  }
}
